import React from "react";
import Information from "../../../components/forms/productForms/information/information";


export default function ThreePageForm() {
  return  <Information />
}
